import React from "react";

function RightSearchBar({ color }: {color: string}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="30"
      fill="none"
      viewBox="0 0 12 30"
    >
      <path
        fill={color}
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 12 7)"
      ></path>
      <path
        fill={color}
        d="M12 10H8v3.25h4V10zM12 13.25H8v3.25h4v-3.25zM12 16.5H8v3.25h4V16.5zM12 19.75H8V23h4v-3.25z"
      ></path>
      <path
        fill={color}
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 8 3)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 8 23)"
      ></path>
      <path fill={color} d="M4 0H0v3h4V0zM4 27H0v3h4v-3z"></path>
      <path
        fill={color}
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 4 3)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 4 23)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 4 20)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 4 17)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 4 13)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 4 10)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 4 7)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 8 20)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 8 17)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V4H0z"
        transform="matrix(-1 0 0 1 8 13)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 8 10)"
      ></path>
      <path
        fill={color}
        d="M0 0H4V3H0z"
        transform="matrix(-1 0 0 1 8 7)"
      ></path>
    </svg>
  );
}

export default RightSearchBar;
